import { Link } from "react-router-dom";
import { useRef, useState, useCallback } from "react";

/** Inverted-dot custom cursor badge for Awwwards */
const AwwwardsBadge = () => {
  const ref = useRef<HTMLAnchorElement>(null);
  const dotRef = useRef<HTMLDivElement>(null);
  const [hovering, setHovering] = useState(false);

  const onMove = useCallback((e: React.MouseEvent) => {
    if (!ref.current || !dotRef.current) return;
    const rect = ref.current.getBoundingClientRect();
    dotRef.current.style.left = `${e.clientX - rect.left}px`;
    dotRef.current.style.top = `${e.clientY - rect.top}px`;
  }, []);

  return (
    <a
      ref={ref}
      href="https://www.awwwards.com/sites/empire"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="View Empire on Awwwards"
      className="absolute top-0 right-0 z-10"
      style={{ cursor: "none" }}
      onClick={(e) => e.stopPropagation()}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      onMouseMove={onMove}>

      <div
        ref={dotRef}
        className="pointer-events-none absolute rounded-full"
        style={{
          width: 28,
          height: 28,
          backgroundColor: "white",
          mixBlendMode: "difference",
          opacity: hovering ? 1 : 0,
          transform: `translate(-50%, -50%) scale(${hovering ? 1 : 0.3})`,
          transition: "opacity 0.15s ease-out, transform 0.15s ease-out"
        }} />

      <svg width="36" height="116" viewBox="0 0 53.08 171.358">
        <path fill="white" d="M0 0h53.08v171.358H0z" />
        <g fill="black">
          <path d="M20.048 153.585v-2.002l6.752-3.757h-6.752v-1.9h10.23v2.002l-6.752 3.757h6.752v1.9zM29.899 142.382a3.317 3.317 0 0 1-1.359 1.293c-.575.297-1.223.446-1.944.446-.721 0-1.369-.149-1.944-.446a3.317 3.317 0 0 1-1.359-1.293c-.331-.564-.497-1.232-.497-2.003 0-.769.166-1.437.497-2.002a3.332 3.332 0 0 1 1.359-1.294c.575-.297 1.224-.445 1.944-.445.722 0 1.369.148 1.944.445a3.326 3.326 0 0 1 1.359 1.294c.33.565.496 1.233.496 2.002.001.77-.166 1.438-.496 2.003m-1.703-3.348c-.435-.331-.967-.497-1.601-.497s-1.167.166-1.601.497c-.434.332-.65.78-.65 1.345s.217 1.014.65 1.346c.434.33.967.496 1.601.496s1.166-.166 1.601-.496c.434-.332.649-.78.649-1.346.001-.565-.215-1.013-.649-1.345M22.912 134.996v-1.812h1.185c-.43-.283-.752-.593-.973-.929-.219-.336-.329-.732-.329-1.19 0-.479.127-.902.38-1.272.254-.37.635-.633 1.141-.79-.478-.262-.851-.591-1.118-.985a2.221 2.221 0 0 1-.402-1.265c0-.682.2-1.218.599-1.607.4-.391.957-.585 1.668-.585h5.218v1.812H25.37c-.682 0-1.023.303-1.023.907 0 .467.264.85.789 1.146.527.299 1.286.446 2.28.446h2.865v1.813H25.37c-.682 0-1.023.303-1.023.906 0 .468.275.851.826 1.147.551.298 1.352.446 2.404.446h2.704v1.812h-7.369zM21.626 122.457c-.225.224-.502.336-.833.336s-.608-.112-.833-.336a1.128 1.128 0 0 1-.336-.833c0-.331.111-.609.336-.833.225-.225.502-.336.833-.336s.608.111.833.336c.225.224.337.502.337.833 0 .332-.112.608-.337.833m1.286-1.739h7.366v1.813h-7.366v-1.813zM22.912 118.668v-1.812h1.185a3.348 3.348 0 0 1-.951-1.009 2.434 2.434 0 0 1-.351-1.272c0-.681.19-1.229.57-1.644.38-.414.931-.621 1.651-.621h5.263v1.812h-4.722c-.418 0-.727.096-.92.285-.195.19-.293.447-.293.769 0 .302.116.58.351.833.233.254.577.458 1.03.613.453.156.992.234 1.615.234h2.938v1.812h-7.366zM29.833 109.129a3.33 3.33 0 0 1-1.432 1.169 4.535 4.535 0 0 1-1.805.373 4.537 4.537 0 0 1-1.807-.373c-.579-.248-1.057-.638-1.432-1.169s-.563-1.196-.563-1.995c0-.771.183-1.413.549-1.93a3.28 3.28 0 0 1 1.382-1.141 4.221 4.221 0 0 1 1.709-.364h.746v5.071c.447-.02.838-.183 1.168-.49.332-.307.498-.724.498-1.248 0-.41-.093-.754-.277-1.031-.186-.278-.473-.529-.863-.753l.542-1.462c.69.303 1.224.724 1.592 1.265.371.541.556 1.235.556 2.083 0 .799-.188 1.464-.563 1.995m-4.085-3.574c-.41.088-.746.261-1.009.52-.262.258-.395.61-.395 1.06 0 .428.137.784.409 1.067.272.282.604.458.994.525v-3.172zM29.833 100.878c-.375.531-.852.921-1.432 1.169a4.552 4.552 0 0 1-3.612 0c-.579-.248-1.057-.638-1.432-1.169s-.563-1.196-.563-1.995c0-.77.183-1.412.549-1.93a3.278 3.278 0 0 1 1.382-1.14 4.222 4.222 0 0 1 1.709-.365h.746v5.072a1.794 1.794 0 0 0 1.168-.49c.332-.307.498-.724.498-1.249 0-.41-.093-.753-.277-1.031-.186-.277-.473-.528-.863-.753l.542-1.462c.69.302 1.224.724 1.592 1.265.371.541.556 1.234.556 2.083 0 .799-.188 1.464-.563 1.995m-4.085-3.573c-.41.088-.746.261-1.009.519-.262.258-.395.611-.395 1.06 0 .429.137.784.409 1.067.272.282.604.458.994.526v-3.172zM35.481 16.926l-4.782 14.969h-3.266l-2.584-9.682-2.584 9.682h-3.268l-4.781-14.969h3.713l2.673 10.276 2.524-10.276h3.445l2.524 10.276 2.674-10.276zM37.979 27.083c1.426 0 2.495 1.068 2.495 2.495 0 1.425-1.069 2.495-2.495 2.495-1.425 0-2.495-1.07-2.495-2.495-.001-1.427 1.07-2.495 2.495-2.495" />
        </g>
      </svg>
    </a>);

};

/* Per-slug logo size tweaks so all cards look visually balanced */
export const logoSizeOverrides: Record<string, string> = {
  "whop-highered": "w-48 md:w-36 max-h-20 md:max-h-16",
  "empire": "w-52 md:w-44 max-h-28 md:max-h-20",
  "humming-ai": "w-48 md:w-36 max-h-20 md:max-h-16",
  "m-r": "w-32 md:w-24 max-h-28 md:max-h-20",
  "c23-labs": "w-32 md:w-32 max-h-16 md:max-h-16",
  "chill-bites-drinks": "w-32 md:w-32 max-h-20 md:max-h-20",
  "exceptional-100-framer-site-development": "w-[80%] md:w-48 max-h-32 md:max-h-24",
  "bloved-publishing": "w-[200%] md:w-96 max-h-40 md:max-h-32"
};

export interface CaseStudyCardData {
  id?: string;
  slug: string;
  title: string;
  subtitle?: string | null;
  category?: string | null;
  image: string;
  logo: string;
}

interface CaseStudyCardProps {
  study: CaseStudyCardData;
  /** Use Link navigation instead of onClick (default: true) */
  asLink?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  className?: string;
}

/**
 * Shared portfolio card used on the homepage carousel and case study pages.
 * Dark-themed card with 4:5 aspect ratio, centered logo overlay, and metadata below.
 */
const CaseStudyCard = ({ study, asLink = true, onClick, className = "" }: CaseStudyCardProps) => {
  const inner =
  <>
      {/* Card image with logo overlay */}
      <div className="relative overflow-hidden aspect-[4/5] bg-white/5 rounded-sm">
        <img
        src={study.image}
        alt={study.title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
        loading="lazy"
        width={400}
        height={500}
        decoding="async" />

        <div className="absolute inset-0 bg-black/35 flex items-center justify-center">
          {study.logo ?
        <img
          src={study.logo}
          alt={`${study.title} logo`}
          className={`${logoSizeOverrides[study.slug] || "w-48 md:w-40 max-h-20 md:max-h-24"} object-contain brightness-0 invert drop-shadow-lg`}
          loading="lazy"
          decoding="async" /> :


        <span className="font-display text-ts-sm md:text-ts-base text-white tracking-wide text-center px-4 drop-shadow-lg italic">
               {study.title}
             </span>
        }
        </div>

        {/* Awwwards badge — Empire only */}
        {study.slug === "empire" && <AwwwardsBadge />}
      </div>

       {/* Text underneath */}
       <div className="mt-3 space-y-0.5">
         <h3 className="font-body text-ts-sm font-medium text-foreground/90 group-hover:text-foreground transition-colors">
           {study.title}
         </h3>
         {study.subtitle &&
      <p className="font-body text-ts-xs font-normal pb-[8px] text-muted-foreground">
             {study.subtitle}
           </p>
      }
         {study.category &&
      <p className="font-body text-[0.625rem] font-normal tracking-[0.15em] uppercase border-t border-border pt-2 mt-1.5 text-muted-foreground">
             {study.category}
           </p>
      }
       </div>
    </>;


  if (asLink) {
    return (
      <Link to={`/work/${study.slug}`} className={`group block ${className}`}>
        {inner}
      </Link>);

  }

  return (
    <div onClick={onClick} className={`group block cursor-pointer ${className}`}>
      {inner}
    </div>);

};

export default CaseStudyCard;